import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';

import { PublicationsService } from './../../services/publications/publications.service';
import { SeoService } from './../../services/seo.service';

@Component({
  selector: 'app-publications',
  templateUrl: './publications.component.html',
  styleUrls: ['./publications.component.scss'],
  // changeDetection: ChangeDetectionStrategy.Default
})
export class PublicationsComponent implements OnInit {


  publications:any = [];
  public filter: any = { title : ''};
  public maxSize: number = 7;
  public directionLinks: boolean = true;
  public autoHide: boolean = false;
  public responsive: boolean = false;
  public config = {
    id: 'pagination',
    itemsPerPage: 6,
    currentPage: 0
  };
  public labels: any = {
    previousLabel: 'Anterior',
    nextLabel: 'Siguiente',
    screenReaderPaginationLabel: 'Paginaión',
    screenReaderPageLabel: 'Pagina',
    screenReaderCurrentLabel: `Te encuentras aqui`
  };




  constructor(
    private publicationsService:PublicationsService,
    private seoService:SeoService
  ) {
    this.seoService.setTagsPage({
      title:'Cptur | Publicaciones',
      description:'Publicaciones',
      image:'/assets/images/logo.png'
    });
  }

  ngOnInit() {
    this.getPublications();
  }

  getPublications(){
    this.publicationsService.getPublications().subscribe(publications => {
      this.publications = publications;
    })
  }

  onPageChange(number: number) {
    this.config.currentPage = number;
  }

}
